import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {CardEnum} from "@/modules/match/enums";
import chance from "@/modules/base/services/chance";
import {Player} from "@/modules/team/entity";
import {Competition, Suspension} from "@/modules/competitions/entity";
import {BeforePlayerSuspendedEvent} from "@/modules/competitions/events/BeforePlayerSuspendedEvent";
import {AfterPlayerSuspendedEvent} from "@/modules/competitions/events/AfterPlayerSuspendedEvent";

@injectable()
export default class SuspensionHandler {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  public async suspend(player: Player, competition: Competition, card: CardEnum) {
    const matches = chance.integer(this.configRepository.get('competitions.suspensions.durations')[card]);

    await player.load('team');

    const suspension = new Suspension();
    suspension.player = player;
    suspension.competition = competition;
    suspension.card = card;
    suspension.totalMatches = matches;
    suspension.remainingMatches = matches;

    await this.em.emitAsync(new BeforePlayerSuspendedEvent(suspension));

    await suspension.save();

    await this.em.emitAsync(new AfterPlayerSuspendedEvent(suspension));
  }

  public async handle(suspension: Suspension) {
    if (suspension.remainingMatches === 1) {
      await suspension.remove();
      return;
    }

    suspension.remainingMatches -= 1;
    await suspension.save();
  }
}
